import script from "./CapitalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CapitalInfo.vue?vue&type=script&setup=true&lang=js"

import "./CapitalInfo.vue?vue&type=style&index=0&id=d595cfa4&lang=scss"

const __exports__ = script;

export default __exports__